

















import { convertRtlStyle } from '@tt4b/ttam-utils';
import { computed, defineComponent } from '@vue/composition-api';
const defaultQRBackground = 'white';
const name = 'ttam-qr-code-preview';
export default defineComponent({
  name,
  components: {
    vueQr: () => import(/* webpackChunkName: "vueQr" */ 'vue-qr').then(res => res.default),
  },
  props: {
    // 生成我二维码图片的大小
    size: {
      type: Number,
      default: 180,
    },
    // 图片的外边距
    margin: {
      type: Number,
      default: 10,
    },
    // 试玩地址 -- 即二维码对应链接地址
    src: {
      type: String,
      required: true,
    },
    correctLevel: {
      type: Number,
      default: 1,
    },
    // 二维码中间的logo图片
    logo: {
      type: String,
      default: '',
    },
    // logo 与 二维码图形之间的间距
    logoMargin: {
      type: Number,
      default: 0,
    },
    // 缩小倍数
    scale: {
      type: Number,
      default: 2,
    },
    // border-radius
    logoCornerRadius: {
      type: Number,
      default: 8,
    },
    backgroundColor: {
      type: String,
      default: defaultQRBackground,
    },
  },
  setup(props) {
    const computedStyle = computed(() =>
      convertRtlStyle({
        width: `${props.size}px`,
        height: `${props.size}px`,
        transform: `scale(${1 / props.scale})`,
      }),
    );

    return {
      name,
      computedStyle,
    };
  },
});
